import { paymentMethodStatsSchema } from "@redotech/redo-dispute-db-schema/dispute-overview-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getDisputeMethodStats = {
  name: "getDisputeMethodStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: paymentMethodStatsSchema,
};
